export const environment = {
  production: true,
  laravel_url: "https://api.signem.app",
  recaptcha_key: "6Lc1fPklAAAAAPCr8Syj30ZNABnvhAiZw8XmKkV4"
};
